export default "__VITE_ASSET__8tYCqcSr__"